import React from "react"

import { css } from '@emotion/react'

const TwoColumns = ({marginTop, children}) => {

    return (
        <div css={marginTop ? [marginTopStyle, main] : main}>
            {children}
        </div>
    )
}

export default TwoColumns

const main = css`
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    gap: 15px 15px;

    @media screen and (min-width: 1000px) {
        grid-template-columns: repeat(2, 1fr);
        gap: 15px 15px;
    }
`

const marginTopStyle = css`
    margin-top: 50px;
`